$(function() {

    $('.js-select2').select2({
        dropdownAutoWidth: true,
        width: '100%'
    });

    $('.js-select2-multiple').select2({
        multiple: true,
        closeOnSelect: false
    });
});
